module.exports = __webpack_public_path__ + "media/images/maps/waze-8e35a1cbb81e8393cb431989032c27c5.png";